import { Stack } from '@mui/material';

import { VoiceContentStateTypes } from 'pages/ContentVoiceBuilderPage/types';

import IncorrectResponseRow from './IncorrectResponseRow';
import NoResponseRow from './NoResponseRow';

type Props = {
    dispatchVoiceContentAction: React.Dispatch<any>;
    isContentLoading: boolean;
    voiceContentState: VoiceContentStateTypes;
};

const FallbackBuilder = ({ dispatchVoiceContentAction, isContentLoading, voiceContentState: state }: Props) => (
    <Stack>
        <NoResponseRow
            dispatchVoiceContentAction={dispatchVoiceContentAction}
            isContentLoading={isContentLoading}
            voiceContentState={state}
        />
        <IncorrectResponseRow
            dispatchVoiceContentAction={dispatchVoiceContentAction}
            isContentLoading={isContentLoading}
            voiceContentState={state}
        />
    </Stack>
);

export default FallbackBuilder;
